import { componentStyle } from '@/styling/util/component-style.ts';

export const dialogStyle = componentStyle({
    borderRadius: '4px',
});
